<template>
  <div>

  
  <div class="ViewAllNews"  v-if="getLocaltypes()==1">
    <div class="New-in-brief">
      <div class="img-box">
        <div class="headfont">
          <h2>{{newsType}}</h2>
        </div>
        <img src="../../assets/70f8d71f956dc03201d54140dc5906a.jpg" />
      </div>

      <div class="el-icon-arrow-news">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>新闻</el-breadcrumb-item>
          <el-breadcrumb-item>{{newsType}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="news-list_contain">
        <div class="menus">
          <div class="menu" @click="getNews(Flash)" v-for="(Flash,index) in FlashList" :key="index">
            <div class="menus_images">
              <img :src="imagepath+Flash.news_FILE_PATH" />
            </div>
            <div id="time-cate">{{ Flash.new_CREATE_DATE}}</div>
            <div class="menus_Name">
              <el-tooltip :content="Flash.news_TITLE" placement="bottom" effect="light" :open-delay="750">
                <span class="span3">{{Flash.news_TITLE}}</span>
              </el-tooltip>
            </div>
            <hr class="hr">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div  v-if="getLocaltypes()==2">
    <div>
      <div >
        <div >
          <h2>{{newsType}}新闻</h2>
        </div>
      </div>

      <!-- <div class="el-icon-arrow-news">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/text' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>新闻</el-breadcrumb-item>
          <el-breadcrumb-item>{{newsType}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div> -->
      <div class="news-list_contain">
        <div class="menus2">
          <div class="menu2" @click="getNews(Flash)" v-for="(Flash,index) in FlashList" :key="index">
            <div class="menus_images" style="min-height: 190px;width: 100%;">
              <img :src="imagepath+Flash.news_FILE_PATH" />
            </div>
            <div style="font-size: 12px;">{{ Flash.new_CREATE_DATE}}</div>
            <div class="menus_Name2">
              <el-tooltip :content="Flash.news_TITLE" placement="bottom" effect="light" :open-delay="750">
                <span class="span4">{{Flash.news_TITLE}}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {getLocaltype} from '../mainConfig/thu'

export default {
  created() {
    this.imagepath = this.$imagepath
    this.getNewsbyType();
  },
  data() {
    return {
      FlashList: [],
      newsType: "",
      imagepath: ''
    };
  },
  methods: {
    getLocaltypes(){
  return getLocaltype();
},
    getNewsbyType() {
      this.newsType = this.$route.query.news_type;

      this.axios.post("/news/getNewsbyType?new_type=" + this.newsType)
        .then((resp) => {
          if (resp.data.status == 1) {
            this.FlashList = resp.data.result
          } else {
            alert("拿取数据失败");
          }
        })
        .catch((err) => {
          this.$message.error("出错");
        });
    },
    getNews(data) {
      this.$router.push({  //核心语句
        path: '/news',   //跳转的路径
        query: {           //路由传参时push和query搭配使用 ，作用时传递参数
          newsid: data.newsid,
          newsHtmlURL: data.newsFilePath
        }
      })
    }
  },
};
</script>

<style scoped>
.news-list_contain {
  margin-top: 20px;
  background-color: #FFFFFF;
  /* height: 2000px; */

}

.New-in-brief {
  width: 64%;
  margin: auto;
  height: 100%;
}

.img-box {
  width: 100%;
  height: 420px;
}

.headfont {
  padding-top: 230px;
  padding-left: 50px;
  position: absolute;
}

img {
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.img-box h2 {
  font-weight: bold;
  font-size: 30px;
  line-height: 1.2;
  margin-bottom: 10px;
  text-transform: uppercase;
  position: relative;
  padding: 13px;
}

.menus {
  width: 95%;
  margin: auto;
  display: flex;
  /* justify-content: space-between; */
  flex-flow: row wrap;
  /* flex-wrap: nowrap; */
}
.menus2 {
  width: 95%;
  margin: auto;
}
.menus:after {
  content: "";
  width: 389.06px;
}

.menu {
  width: 30%;
  height: 220px;
  margin: 10px;
  margin-top: 40px;
}
.menu2 {
width: 100%;
  margin-top: 10px;
}
.menus_images {
  width: 100%;
  height: 80%;
}

.menus_Name {
  height: 42px;
  margin-top: 10px;
}
.menus_Name2 {
  height: 42px;

}
.span3 {
  height: 42px;
  width: 215.42px;
  font-size: 15px;
  /* line-height: 10px; */
  /* z-index: 2; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
  letter-spacing: 1px;
  white-space: normal;
  word-break: break-all;

  /* word-wrap: break-word; */
}
.span4 {
  height: 42px;

  font-size: 15px;
  /* line-height: 10px; */
  /* z-index: 2; */
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
  display: -webkit-box;
  overflow: hidden;
  letter-spacing: 1px;
  white-space: normal;
  word-break: break-all;

  /* word-wrap: break-word; */
}
#time-cate {
  width: 120px;
  height: 12px;
  text-align: center;

  padding-left: 10px;
}

.hr {

  position: absolute;
  width: 231.1px;

  border: solid black;
}

.ViewAllNews {
  background: #F4F4F4;
}

.el-icon-arrow-news {
  margin-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/work/ViewAllNews.vue